/**
 * AAA IDP redux actions
 * 
 */
import { ACCEPT_COOKIES, ACCEPT_TERMS, ACCEPT_MARKETING_CONSENT, APPLICATION_START, ADDRESS_FIELDS_TOGGLE, ADDRESS_USE_SAME_TOGGLE, CARD_HOLDER, CONTENT, CREDIT_CARD, CVV, DELIVERY_ADDRESS, DELIVERY_ADDRESS_REQUIRED_ATTRIBUTE, DELIVERY_ADDRESS_ADDRESS_FULL_NAME, DELIVERY_ADDRESS_FIELDS_TOGGLE, DELIVERY_ADDRESS_COUNTRY, DELIVERY_ADDRESS_COUNTRY_ERROR, DELIVERY_ADDRESS_LOCALITY, DELIVERY_ADDRESS_POSTCODE, DELIVERY_ADDRESS_STATE, DELIVERY_ADDRESS_STREET, DELIVERY_INT, DELIVERY_METHOD, DELIVERY_PICK_UP_STORE, DELIVERY_PICK_UP_STORE_REQUIRED_ATTRIBUTE, DELIVERY_PICKUP_PERSON, DELIVERY_PICKUP_PERSON_REQUIRED_ATTRIBUTE, CONSENT_FORM, CONSENT_FORM_REQUIRED_ATTRIBUTE, CONSENT_FORM_ERROR, EXPIRY_MONTH, EXPIRY_YEAR, AUTO_CLUB, CLEAR_DELIVERY_ADDRESS, CLEAR_LICENCE_ADDRESS, CLONE_LICENCE_ADDRESS, PHONE_COUNTRY_CODE, DELETE, DATE_OF_BIRTH, DATE_OF_TRAVEL, CONFIRM_EMAIL, EMAIL, FIRST_NAME, GATEWAY, ADDRESS_FINDER, IMAGE, IMAGE_ERROR, IMAGE_ERROR_CLEAR, IMAGE_UPLOADED, PHONE_NUMBER, LAST_NAME, LICENCE_ADDRESS, LICENCE_ADDRESS_LOCALITY, LICENCE_ADDRESS_POSTCODE, LICENCE_ADDRESS_STATE, LICENCE_ADDRESS_STREET, LICENCE_CLASS, LICENCE_EXPIRY, LICENCE_NUMBER, LOCALITY, MEMBERSHIP_NUMBER, MIDDLE_NAME, PLACE_OF_BIRTH, POSTAGE, SET_I18N, STATE_OF_ISSUE, TITLE, TRANSACTION, VALIDATE, VALIDATE_ADDRESS } from '../actions/types';
export function acceptCookies(value) {
  return {
    type: ACCEPT_COOKIES,
    value
  };
}
export function acceptTerms(value) {
  return {
    type: ACCEPT_TERMS,
    value
  };
}
export function acceptMarketingConsent(value) {
  return {
    type: ACCEPT_MARKETING_CONSENT,
    value
  };
}
export function addressFinder(results, name) {
  return {
    type: ADDRESS_FINDER,
    name,
    results
  };
}
export function phoneCountryCode(value) {
  return {
    type: PHONE_COUNTRY_CODE,
    value
  };
}
export function addressFieldsToggle(value) {
  return {
    type: ADDRESS_FIELDS_TOGGLE,
    value
  };
}
export function addressDeliveryFieldsToggle(value) {
  return {
    type: DELIVERY_ADDRESS_FIELDS_TOGGLE,
    value
  };
}
export function addressUseSameToggle(value) {
  return {
    type: ADDRESS_USE_SAME_TOGGLE,
    value
  };
}
export function application(value) {
  return {
    type: APPLICATION_START,
    value
  };
}
export function autoClub(value) {
  return {
    type: AUTO_CLUB,
    value
  };
}
export function cardHolder(value) {
  return {
    type: CARD_HOLDER,
    value
  };
}
export function setContent(value) {
  return {
    type: CONTENT,
    value
  };
}
export function creditCard(value) {
  return {
    type: CREDIT_CARD,
    value
  };
}
export function cvv(value) {
  return {
    type: CVV,
    value
  };
}
export function clearDeliveryAddress() {
  return {
    type: CLEAR_DELIVERY_ADDRESS
  };
}
export function clearLicenceAddress() {
  return {
    type: CLEAR_LICENCE_ADDRESS
  };
}
export function cloneLicenceAddress() {
  return {
    type: CLONE_LICENCE_ADDRESS
  };
}
export function dateOfBirth(value) {
  return {
    type: DATE_OF_BIRTH,
    value
  };
}
export function dateOfTravel(value) {
  return {
    type: DATE_OF_TRAVEL,
    value
  };
}
export function deleteAll() {
  return {
    type: DELETE,
    value: ''
  };
}
export function expiryMonth(value) {
  return {
    type: EXPIRY_MONTH,
    value
  };
}
export function expiryYear(value) {
  return {
    type: EXPIRY_YEAR,
    value
  };
}
export function email(value) {
  return {
    type: EMAIL,
    value
  };
}
export function confirmEmail(value) {
  return {
    type: CONFIRM_EMAIL,
    value
  };
}
export function firstName(value) {
  return {
    type: FIRST_NAME,
    value
  };
}
export function gateway(value) {
  return {
    type: GATEWAY,
    value
  };
}
export function image(name, value) {
  return {
    name,
    type: IMAGE,
    value
  };
}
export function imageError(name, error, message) {
  return {
    name,
    error,
    message,
    type: IMAGE_ERROR
  };
}
export function imageErrorClear(name) {
  return {
    type: IMAGE_ERROR_CLEAR,
    name
  };
}
export function imageUploaded(name, uploaded) {
  return {
    name,
    type: IMAGE_UPLOADED,
    uploaded
  };
}
export function phoneNumber(value) {
  return {
    type: PHONE_NUMBER,
    value
  };
}
export function lastName(value) {
  return {
    type: LAST_NAME,
    value
  };
}
export function licenceAddress(value) {
  return {
    type: LICENCE_ADDRESS,
    value
  };
}
export function licenceClass(value) {
  return {
    type: LICENCE_CLASS,
    value
  };
}
export function deliveryAddress(value) {
  return {
    type: DELIVERY_ADDRESS,
    value
  };
}
export function deliveryAddressRequiredAttribute(required) {
  return {
    type: DELIVERY_ADDRESS_REQUIRED_ATTRIBUTE,
    required
  };
}
export function deliveryInt(value) {
  return {
    type: DELIVERY_INT,
    value
  };
}
export function deliveryMethod(value) {
  return {
    type: DELIVERY_METHOD,
    value
  };
}
export function deliveryPickUpStore(value) {
  return {
    type: DELIVERY_PICK_UP_STORE,
    value
  };
}
export function deliveryPickUpStoreRequiredAttribute(required) {
  return {
    type: DELIVERY_PICK_UP_STORE_REQUIRED_ATTRIBUTE,
    required
  };
}
export function deliveryPickupPerson(value) {
  return {
    type: DELIVERY_PICKUP_PERSON,
    value
  };
}
export function deliveryPickupPersonRequiredAttribute(required) {
  return {
    type: DELIVERY_PICKUP_PERSON_REQUIRED_ATTRIBUTE,
    required
  };
}
export function consentForm(value, fileName) {
  return {
    type: CONSENT_FORM,
    value,
    fileName
  };
}
export function consentFormRequiredAttribute(required) {
  return {
    type: CONSENT_FORM_REQUIRED_ATTRIBUTE,
    required
  };
}
export function consentFormError(error, message) {
  return {
    type: CONSENT_FORM_ERROR,
    error,
    message
  };
}
export function licenceDeliveryAddressFullName(value) {
  return {
    type: DELIVERY_ADDRESS_ADDRESS_FULL_NAME,
    value
  };
}
export function licenceDeliveryAddressLocality(value) {
  return {
    type: DELIVERY_ADDRESS_LOCALITY,
    value
  };
}
export function licenceDeliveryAddressPostcode(value) {
  return {
    type: DELIVERY_ADDRESS_POSTCODE,
    value
  };
}
export function licenceDeliveryAddressState(value) {
  return {
    type: DELIVERY_ADDRESS_STATE,
    value
  };
}
export function licenceDeliveryAddressStreet(value) {
  return {
    type: DELIVERY_ADDRESS_STREET,
    value
  };
}
export function licenceAddressLocality(value) {
  return {
    type: LICENCE_ADDRESS_LOCALITY,
    value
  };
}
export function licenceAddressPostcode(value) {
  return {
    type: LICENCE_ADDRESS_POSTCODE,
    value
  };
}
export function licenceAddressState(value) {
  return {
    type: LICENCE_ADDRESS_STATE,
    value
  };
}
export function licenceAddressStreet(value) {
  return {
    type: LICENCE_ADDRESS_STREET,
    value
  };
}
export function licenceDeliveryAddressCountry(value) {
  return {
    type: DELIVERY_ADDRESS_COUNTRY,
    value
  };
}
export function licenceDeliveryAddressCountryReset() {
  return {
    type: DELIVERY_ADDRESS_COUNTRY_ERROR
  };
}
export function licenceExpiry(value) {
  return {
    type: LICENCE_EXPIRY,
    value
  };
}
export function licenceNumber(value) {
  return {
    type: LICENCE_NUMBER,
    value
  };
}
export function locality(value) {
  return {
    type: LOCALITY,
    value
  };
}
export function membershipNumber(value) {
  return {
    type: MEMBERSHIP_NUMBER,
    value
  };
}
export function middleName(value) {
  return {
    type: MIDDLE_NAME,
    value
  };
}
export function placeOfBirth(value) {
  return {
    type: PLACE_OF_BIRTH,
    value
  };
}
export function postage(value) {
  return {
    type: POSTAGE,
    value
  };
}
export function setI18n(data) {
  return {
    type: SET_I18N,
    data
  };
}
export function stateOfIssue(value) {
  return {
    type: STATE_OF_ISSUE,
    value
  };
}
export function title(value) {
  return {
    type: TITLE,
    value
  };
}
export function transaction(value) {
  return {
    type: TRANSACTION,
    value
  };
}
export function validateAddress(value) {
  return {
    type: VALIDATE_ADDRESS,
    value
  };
}
export function validate() {
  return {
    type: VALIDATE,
    value: ''
  };
}